import { Component, ViewChild, Input, Output, OnChanges, OnInit, SimpleChanges, EventEmitter  } from '@angular/core';
import { EdgeInterfaceDto } from '../../dto/gateway-dto';
import GatewayDto  from '../../dto/gateway-dto';
import  { getGatewayInterfaceListingDatatableConfig }
from './gateway-interface-configuration.dt.config';

@Component({
 selector: 'gateway-interface-configuration',
  template: require('./gateway-interface-configuration.html')
})

export default class GatewayInterfaceConfiguration implements OnChanges {
    @Input('gateway') gateway: GatewayDto;
    @Input('isEditMode') isEditMode: boolean = false;

    @Input('hasValidInterfaces') hasValidInterfaces: false;
    @Output('onAddInterface') addInterface = new EventEmitter();
    @Output('onDeleteInterface') deleteInterface = new EventEmitter();
    @Output('onEditInterface') editInterface = new EventEmitter();

    public canEditInterface: boolean = false;
    public canDeleteInterface: boolean = false;
    public selectedInterface: EdgeInterfaceDto;

    private tableSettings: Object = {};
    private tableConfig: Object = {};
    private addButtonText: string = '';
    private addButtonTitle: string = '';

    constructor() {
         this.tableConfig = getGatewayInterfaceListingDatatableConfig();
         Object.assign(this.tableSettings, this.tableConfig, {'data': []});
         this.addButtonText = 'Add';
         this.addButtonTitle = 'Add Interface or SubInterface';
    }

    ngOnChanges(change: SimpleChanges) {
        if (this.isEditMode) {
            this.addButtonText = "Add SubInterface";
            this.addButtonTitle = "Add SubInterface"
        }
    }

    onCreate(event) {
        this.addInterface.emit({
        });
    }

    onEdit(event) {
        this.editInterface.emit({
            'selectedInterface': this.selectedInterface
        });
    }

    onDelete(event) {
        this.deleteInterface.emit({
            'selectedInterface': this.selectedInterface
        });
    }

    onInterfaceSelected(event){
        if (event && event.value && event.value instanceof Array ) {
           if (event.value[0]) {
               this.selectedInterface = event.value[0] as EdgeInterfaceDto;
               this.canEditInterface = true;
               this.canDeleteInterface = true;
           } else {
               this.selectedInterface = null;
               this.canEditInterface = false;
               this.canDeleteInterface = false;
           }
        }
    }
    disableAdd() {
        // TODO
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/networking/networking-vc/gateways/dialogs/wizard-steps/gateway-interface-configuration.component.ts